import { LogoutOutlined, MenuOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Col,
  Divider,
  Dropdown,
  Menu,
  Modal,
  Row,
  Segmented,
  Tooltip,
  Typography,
} from 'antd';
import React, { useState } from 'react';
import { useGetIdentity, ReduxState } from 'react-admin';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setViewMode } from '../../actions/uiActions';
import { Link } from 'react-router-dom';
// @ts-ignore
import logo from '../../assets/img/netorca.png';
import Breadcrumbs from './Breadcrumbs';
import SearchBar from '../Common/SearchBar';
import Licenses from '../Licenses';
import WelcomeScreen from '../Welcome';
import useGetGeneralSettings from '../../providers/useGetGeneralSettings';
import { getActiveMembership } from '@src/components/Common/utils';
import ActivateMembership from '../Teams/SubComponents/ActivateMembership';

const { Text } = Typography;

const TopBar = ({ pathName, toggleSidebar, logout }: { pathName: string; toggleSidebar: () => void; logout: any }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const generalSettings = useGetGeneralSettings();
  const [showWelcomeScreen, setShowWelcomeScreen] = useState(false);
  const [isLicenseModalOpen, setIsLicenseModalOpen] = useState(false);
  const feedback = generalSettings.find(setting => setting.name == 'Feedback');
  const { identity } = useGetIdentity();
  const activeMembership = getActiveMembership();
  const activeTeamName = activeMembership?.team?.name;
  const viewMode = localStorage.getItem('pov_preference') || useSelector((state: ReduxState) => state.ui.viewMode);

  const handleViewChange = (value: string) => {
    dispatch(setViewMode(value));
    localStorage.setItem('pov_preference', value);
    history.push('/');
  };

  const userMenu = (
    <Menu style={{ width: '250px' }}>
      <Menu.ItemGroup>
        <Link to="/profile/" style={{ color: 'inherit', textDecoration: 'none' }}>
          <Row align="middle">
            <Col style={{ textAlign: 'center' }} span={6}>
              <FontAwesomeIcon style={{ width: '24px', height: '24px' }} icon={faUserCircle} />
            </Col>
            <Col span={18}>
              <Row><Text strong>{identity?.first_name} {identity?.last_name}</Text></Row>
              <Row><Text type="secondary">{identity?.username}</Text></Row>
            </Col>
          </Row>
        </Link>
        <Divider style={{ margin: '4px 0' }} />
        <div style={{ padding: '4px 12px' }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>ACTIVE TEAM</Text>
        </div>
        <ActivateMembership />
        <Divider style={{ margin: '4px 0' }} />
        {feedback && feedback?.ENABLED && (
          <Menu.Item key="3">
            <a href={feedback.config?.feedback_link} target="_blank">Report a problem</a>
          </Menu.Item>
        )}
        <Menu.Item key="2" onClick={() => setIsLicenseModalOpen(true)}>
          Software Licenses
          <Modal
            title="License Attributions"
            open={isLicenseModalOpen}
            onCancel={(e) => { e.stopPropagation(); setIsLicenseModalOpen(false); }}
            footer={null}
          >
            {isLicenseModalOpen && <Licenses />}
          </Modal>
        </Menu.Item>
        <Menu.Item key="1" onClick={logout} icon={<LogoutOutlined />}>
          Log Out
        </Menu.Item>
      </Menu.ItemGroup>
    </Menu>
  );

  return (
    <div className="layout-v2-topbar">
      <div className="layout-v2-topbar-left">
        <a href="/#"><img src={logo} alt="NetOrca" style={{ height: '40px' }} /></a>
        <Segmented
          className="dashboard-view-toggle"
          value={viewMode}
          onChange={(value) => handleViewChange(value as string)}
          options={[
            { label: 'Consumer', value: 'CONSUMER' },
            { label: 'Service Owner', value: 'SERVICE_OWNER' },
          ]}
        />
        <Breadcrumbs path={pathName} />
      </div>
      <div className="layout-v2-topbar-right">
        <SearchBar style={{ width: 'clamp(100px, 30vw, 450px)' }} className="filter-select"/>

        <Tooltip title="Getting Started">
          <QuestionCircleOutlined
            className="topbar-icon-btn"
            onClick={() => setShowWelcomeScreen(true)}
          />
        </Tooltip>

        <div className="topbar-divider" />

        <Dropdown dropdownRender={() => userMenu} trigger={['click']}>
          <a href="#" className="topbar-user-trigger" onClick={(e) => e.preventDefault()}>
            <FontAwesomeIcon className="topbar-user-avatar" icon={faUserCircle} />
            {activeTeamName && <span className="topbar-team-name">{activeTeamName}</span>}
          </a>
        </Dropdown>

        <Button
          type="text"
          className="sidebar-toggler"
          onClick={toggleSidebar}
          icon={<MenuOutlined />}
        />
      </div>
      {showWelcomeScreen && <WelcomeScreen onClose={() => setShowWelcomeScreen(false)} />}
    </div>
  );
};

export default TopBar;
